import {
  FileImageOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  FileOutlined,
} from '@ant-design/icons';
import * as XLSX from 'xlsx';

const getFileIcon = extension => {
  // You can define the mapping of file extensions to icons as per your preference
  if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
    return <FileImageOutlined />;
  } else if (extension === 'pdf') {
    return <FilePdfOutlined />;
  } else if (extension === 'xlsx' || extension === 'xls') {
    return <FileExcelOutlined />;
  } else {
    return <FileOutlined />;
  }
};

const extractFileExtension = url => {
  const parts = url.split('.');
  const extension = parts[parts.length - 1].split('?')[0];
  return extension.toLowerCase();
};

const getFileIconByURL = url => {
  const extension = extractFileExtension(url);
  return getFileIcon(extension);
};

function objectToQueryString(obj) {
  const queryParams = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
      queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
  }

  return queryParams.join('&');
}

function exportToExcel(data, fileName) {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const dataBlob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});

  const url = window.URL.createObjectURL(dataBlob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName + '.xlsx');
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function formatLabel(label) {
  let result = '';

  for (let i = 0; i < label.length; i++) {
    const char = label[i];

    if (char === char.toUpperCase() && char !== char.toLowerCase()) {
      // Add space before uppercase letters
      if (i > 0) {
        result += ' ';
      }
    }

    result += char;
  }

  return result;
}

export { getFileIcon, extractFileExtension, getFileIconByURL, objectToQueryString, exportToExcel, formatLabel };
